import { ReceiptTypeEnum } from "@figurepos/fgr-lib-business-logic/lib/receipts/types"

export const LabelPrinterPaperTypeEnum = {
    OneInch: "one-inch",
    TwoInch: "two-inch",
}

export type LabelPrinterPaperType = (typeof LabelPrinterPaperTypeEnum)[keyof typeof LabelPrinterPaperTypeEnum]

export const ReceiptModifierGroupNameDisplayingEnum = {
    ForGroupPriced: "for-group-priced",
    Always: "always",
    Never: "never",
}

export type ReceiptModifierGroupNameDisplayingType =
    (typeof ReceiptModifierGroupNameDisplayingEnum)[keyof typeof ReceiptModifierGroupNameDisplayingEnum]

export const SalesReceiptPrintingBehaviorUponAcceptingOrderEnum = {
    PrintMerchantReceipt: "PrintMerchantReceipt",
    PrintCustomerReceipt: "PrintCustomerReceipt",
    PrintMerchantAndCustomerReceipt: "PrintMerchantAndCustomerReceipt",
    PrintNoReceipt: "PrintNoReceipt",
}
// prettier-ignore

export type SalesReceiptPrintingBehaviorUponAcceptingOrderType = typeof SalesReceiptPrintingBehaviorUponAcceptingOrderEnum[keyof typeof SalesReceiptPrintingBehaviorUponAcceptingOrderEnum];

export const PrinterTypeForPrinterSettingsEnum = {
    AllPrinters: "ALL",
    LinePrinters: "LINE",
    RasterPrinters: "RASTER",
    Disabled: "DISABLED",
}

export enum OrderButtonMode {
    Disabled = "DISABLED",
    Quick = "QUICK",
    Custom = "CUSTOM",
}

export type PrinterTypeForPrinterSettings =
    (typeof PrinterTypeForPrinterSettingsEnum)[keyof typeof PrinterTypeForPrinterSettingsEnum]

export const CourseLineModeEnum = {
    Disabled: "disabled",
    Simple: "simple",
    Complex: "complex",
    Optimized: "optimized",
}

export type CourseLineMode = (typeof CourseLineModeEnum)[keyof typeof CourseLineModeEnum]

export const FirstCourseFiringBehaviorEnum = {
    FullOrder: "full-order",
    CourseOnly: "course-only",
}

export enum PrintUnorderedItemsInAdvanceMode {
    Never = "never",
    Always = "always",
    FirstPrint = "first-print",
}

export const SelectedReceiptModeEnum = {
    Sale: "normal",
    Check: "check",
    Delivery: "delivery",
    ToGo: "to-go",
}

export type SelectedReceiptMode = (typeof SelectedReceiptModeEnum)[keyof typeof SelectedReceiptModeEnum]

export const SALE_RECEIPT_TYPES = [
    ReceiptTypeEnum.SaleCustomer,
    ReceiptTypeEnum.SaleMerchant,
    ReceiptTypeEnum.SaleCheck,
]

export const SALE_RECEIPT_TYPES_NO_CHECK = [ReceiptTypeEnum.SaleCustomer, ReceiptTypeEnum.SaleMerchant]

export const SALE_RECEIPT_TYPES_FOR_MULTI_SELECTS = [
    {
        key: ReceiptTypeEnum.SaleCustomer,
        label: "Customer Copy",
    },
    {
        key: ReceiptTypeEnum.SaleMerchant,
        label: "Merchant Copy",
    },
    {
        key: ReceiptTypeEnum.SaleCheck,
        label: "Check Receipt",
    },
]

export const SALE_RECEIPT_TYPES_NO_CHECK_FOR_MULTI_SELECTS = [
    {
        key: ReceiptTypeEnum.SaleCustomer,
        label: "Customer Copy",
    },
    {
        key: ReceiptTypeEnum.SaleMerchant,
        label: "Merchant Copy",
    },
]

export enum HalfToneImageFilterName {
    CIDotScreen = "CIDotScreen",
    CICircularScreen = "CICircularScreen",
    CIHatchedScreen = "CIHatchedScreen",
    CILineScreen = "CILineScreen",
}

export enum OrderItemsSortBy {
    Timestamp = "timestamp",
    SeatNumber = "seat-number",
    Alphabetical = "alphabetical",
}

export enum ReadyScheduledTimePosition {
    Top = "top",
    Bottom = "bottom",
}
